


























import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import snacks from '@/app/services/snacks'
import evaluationService from '@/evaluations/services/evaluation-service'

@Component
export default class Home extends Vue {
  private loading = false

  private refNumber = ''

  private async gotoEvaluation() {
    localStorage.setItem('refNumber', this.refNumber)
    if (this.refNumber && this.refNumber.length > 0) {
      const result = await evaluationService.findOneByRefAsync(this.refNumber)
      if (result) {
        this.$router.push({ name: 'evaluationdetails', params: { lang: this.$i18n.locale, id: result.id } })
      } else {
        snacks.error('Evaluierung nicht gefunden.')
      }
    } else {
      snacks.error('Bitte geben Sie eine Referenznummer ein.')
    }
  }

  private async created() {
    const savedRefNumber = localStorage.getItem('refNumber')
    if (savedRefNumber) {
      this.refNumber = savedRefNumber
    }
  }
}
